import { takeEvery, put } from "redux-saga/effects";
import { request2, request } from '../../../api/Service';
import { getErrorMessage } from '../../../components/utils/errorHandler';
import { toast } from 'react-toastify';
import history from '../../../router/browserrouter';

export default function* watcherDeleteAccountSaga() {
    yield takeEvery("DELETE_ACCOUNT", workerSaga);
}

function* workerSaga(action) {
    try {
        yield put({ type: "DISPLAY_LOADER" });
        let payload = {};
        var url = '/api/Admin/delete-account?id=' + action.payload;
        yield request("post", action.payload, url).then(response => {
            payload = response;
        });
        toast.success(payload)
        var formatUrl = '/api/Admin/get-accounts'
        yield request("get", action.payload, formatUrl).then(response => {
            payload = response;
        });
        yield put({ type: "ACCOUNT_LIST", payload: payload })


        yield put({ type: "DISPLAY_LOADER" });
    } catch (e) {
        yield put({ type: "LOADING_BUTTON_SPINNER" });
        console.log("delete-order-delivery-saga", e)
        yield put({ type: "DISPLAY_LOADER" });
        console.log("delete-order-delivery-saga", e.response)
        console.log(e.response)
        const errorMessage = getErrorMessage(e.response);
        toast.error(errorMessage);
        yield put({ type: "API_ERRORED", payload: e });
    }
}
